<ng-container *ngIf="hasNotes" class="ion-margin-top">
    <ion-label *ngFor="let preparedNote of preparedNotes" class="ion-no-margin ion-margin-top" color="dark">
        <h3 class="ion-no-margin" [innerHtml]="preparedNote"></h3>
    </ion-label>
</ng-container>